export default function downloadResource(url: string) {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'download');
  link.click();
}
